import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload?.length) {
    return (
      <div className="bg-white p-3 border border-gray-300 rounded-lg shadow-md text-xs">
        {payload.map((entry, index) => (
          <p key={index} style={{ color: entry.color }}>
            {entry.name}: {entry.value}
          </p>
        ))}
      </div>
    );
  }
  return null;
};

export default function MonthlyActivityChart({ monthlyTrend = null, className = '' }) {
  // Transformer les données
  const chartData = React.useMemo(() => {
    if (!monthlyTrend?.months || !Array.isArray(monthlyTrend.months)) {
      return [];
    }

    return monthlyTrend.months.map((entry) => {
      const monthKey = entry?.month ? `${entry.month}-01` : null;
      const date = monthKey ? new Date(monthKey) : null;
      const label = date
        ? date.toLocaleDateString('fr-FR', { month: 'short' })
        : entry?.month || 'N/A';

      return {
        mois: label,
        sondages: Number(entry?.count ?? 0),
        reponses: Number(entry?.responses ?? 0),
      };
    });
  }, [monthlyTrend]);

  return (
    <div className={`flex flex-col rounded-lg p-6 bg-white shadow-sm border border-gray-100 ${className}`}>
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Activité mensuelle</h3>
      
      <div className="flex-1 min-h-[300px] w-full">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
            <XAxis
              dataKey="mois"
              tick={{ fontSize: 12, fill: '#6B7280' }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              tick={{ fontSize: 12, fill: '#6B7280' }}
              axisLine={false}
              tickLine={false}
            />
            <Tooltip content={<CustomTooltip />} />
            {/* <Legend
              wrapperStyle={{ paddingTop: '20px' }}
              iconType="square"
            /> */}
            <Bar
              dataKey="sondages"
              fill="#00796B"
              radius={[4, 4, 0, 0]}
              name="Sondages"
            />
            <Bar
              dataKey="reponses"
              fill="#FFA500"
              radius={[4, 4, 0, 0]}
              name="Réponses"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
